<template>
  <section class="role-models">
    <header class="section-header">
      <h2 class="form-title h3">Who are your Role Models?</h2>
      <p>Add your Role Models using the adjacent form. The format doesn't matter so much as long as you know who you are
         referencing. <strong>In most cases, first name is sufficient</strong>.
         </p>
      <p>For example, if two of your role models share the same first name, <strong>you may want to include their
         last name or initial to differentiate</strong>.</p>

    </header>
    <div class="section-body">
      <div class="input-wrapper" v-for="(roleModel, index) in $parent.roleModels" :key="roleModel.id">
        <input @keyup="updateRoleModel($event, index)" :value="roleModel.name"
               @keyup.enter="addRoleModelOnEnter($event, index)" ref="roleModel"
               placeholder="Enter a role model's name">
        <span class="delete" @click="removeRoleModel(index)">X</span>
      </div>
      <div class="add-role-model-wrapper">
        <button class="button primary filled add-role-model" @click="addRoleModel()">Add Role Model</button>
      </div>
      <p class="next-step-message">After entering all of your role models, <strong>continue on below to the next step</strong>.</p>
    </div>
    <footer class="section-footer">

      <div class="next-prev-step">
        <button class="button accent-1 hollow" @click="$parent.previousStep()">Prev Step</button>
        <button class="button accent-1 filled" @click="$parent.nextStep(); trimRoleModels()" :disabled="roleModelsEmpty">Next Step</button>
      </div>
    </footer>
  </section>
</template>

<script>

export default {
  props: {},
  data() {
    return {};
  },
  mounted() {
    this.$refs["roleModel"][0].focus();
  },
  computed: {
    roleModelsEmpty() {
      let roleModels = [];
      for (let i = 0; i < this.$parent.roleModels.length; i++) {
        if (this.$parent.roleModels[i].name) {
          roleModels.push(this.$parent.roleModels[i]);
        }

      }
      return roleModels.length === 0;
    },
  },
  methods:  {
    generateId() {
      return window.crypto.randomUUID()
    },
    addRoleModel() {
      this.$parent.roleModels.push({id: this.generateId, name: "", traits: [""]})
      setTimeout(() => {
        this.$refs["roleModel"][this.$parent.roleModels.length - 1].focus();
      }, 20)
    },
    addRoleModelOnEnter(event, index) {
      if (event.target.value) {
        this.$parent.roleModels.push({id: this.generateId, name: "", traits: [""]});
        // console.log(this.$refs["roleModel"][index])
        setTimeout(() => {
          this.$refs["roleModel"][index + 1].focus();
        }, 20)

      }
    },
    updateRoleModel(event, index) {
      this.$parent.roleModels[index].name = event.target.value;
    },
    removeRoleModel(index) {
      this.$parent.roleModels.splice(index, 1);
    },
    trimRoleModels() {
      let roleModels = [];
      for (let i = 0; i < this.$parent.roleModels.length; i++) {

        // console.log(roleModels[i].traits[j]);
        if (this.$parent.roleModels[i].name) {
          roleModels.push(this.$parent.roleModels[i]);
        }

      }
      this.$parent.roleModels = roleModels;
    }
  }
}
</script>
